import { render, staticRenderFns } from "./ExternalDeliveryTargets.vue?vue&type=template&id=400ad08e&scoped=true&"
import script from "./ExternalDeliveryTargets.vue?vue&type=script&lang=js&"
export * from "./ExternalDeliveryTargets.vue?vue&type=script&lang=js&"
import style0 from "./ExternalDeliveryTargets.vue?vue&type=style&index=0&id=400ad08e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400ad08e",
  null
  
)

export default component.exports